"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: billing/bill.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbilling%2Fbill.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bill = void 0;
const amount_1 = require("../common/amount");
const primary_account_type_1 = require("../common/primary-account-type");
const bill_status_1 = require("./bill-status");
const statement_context_1 = require("./statement-context");
const statement_period_1 = require("./statement-period");
const protobufPackage = 'com.step.billing.proto';
function createBaseBill() {
    return {
        id: '',
        primaryAccountId: '',
        type: primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE,
        statementId: '',
        period: statement_period_1.StatementPeriod.fromPartial({}),
        amountDue: amount_1.Amount.fromPartial({}),
        remainingAmountDue: amount_1.Amount.fromPartial({}),
        minimumPayment: amount_1.Amount.fromPartial({}),
        amountPaid: amount_1.Amount.fromPartial({}),
        disputeAdjustment: amount_1.Amount.fromPartial({}),
        status: bill_status_1.BillStatus.INVALID_BILL_STATUS,
        context: statement_context_1.StatementContext.fromPartial({}),
        dueAtMs: '0',
        lastPaymentAtMs: '0',
        fullyPaidAtMs: '0',
        isCompleted: false,
    };
}
exports.Bill = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            statementId: isSet(object.statementId) ? globalThis.String(object.statementId) : '',
            period: isSet(object.period)
                ? statement_period_1.StatementPeriod.fromJSON(object.period)
                : statement_period_1.StatementPeriod.fromPartial({}),
            amountDue: isSet(object.amountDue)
                ? amount_1.Amount.fromJSON(object.amountDue)
                : amount_1.Amount.fromPartial({}),
            remainingAmountDue: isSet(object.remainingAmountDue)
                ? amount_1.Amount.fromJSON(object.remainingAmountDue)
                : amount_1.Amount.fromPartial({}),
            minimumPayment: isSet(object.minimumPayment)
                ? amount_1.Amount.fromJSON(object.minimumPayment)
                : amount_1.Amount.fromPartial({}),
            amountPaid: isSet(object.amountPaid)
                ? amount_1.Amount.fromJSON(object.amountPaid)
                : amount_1.Amount.fromPartial({}),
            disputeAdjustment: isSet(object.disputeAdjustment)
                ? amount_1.Amount.fromJSON(object.disputeAdjustment)
                : amount_1.Amount.fromPartial({}),
            status: isSet(object.status)
                ? (0, bill_status_1.billStatusFromJSON)(object.status)
                : bill_status_1.BillStatus.INVALID_BILL_STATUS,
            context: isSet(object.context)
                ? statement_context_1.StatementContext.fromJSON(object.context)
                : statement_context_1.StatementContext.fromPartial({}),
            dueAtMs: isSet(object.dueAtMs) ? globalThis.String(object.dueAtMs) : '0',
            isCompleted: isSet(object.isCompleted) ? globalThis.Boolean(object.isCompleted) : false,
        };
        if (isSet(object.type)) {
            message.type = (0, primary_account_type_1.primaryAccountTypeFromJSON)(object.type);
        }
        if (isSet(object.lastPaymentAtMs)) {
            message.lastPaymentAtMs = globalThis.String(object.lastPaymentAtMs);
        }
        if (isSet(object.fullyPaidAtMs)) {
            message.fullyPaidAtMs = globalThis.String(object.fullyPaidAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.type !== undefined && message.type !== primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE) {
            obj.type = (0, primary_account_type_1.primaryAccountTypeToJSON)(message.type);
        }
        if (message.statementId !== '') {
            obj.statementId = message.statementId;
        }
        if (message.period !== undefined) {
            obj.period = statement_period_1.StatementPeriod.toJSON(message.period);
        }
        if (message.amountDue !== undefined) {
            obj.amountDue = amount_1.Amount.toJSON(message.amountDue);
        }
        if (message.remainingAmountDue !== undefined) {
            obj.remainingAmountDue = amount_1.Amount.toJSON(message.remainingAmountDue);
        }
        if (message.minimumPayment !== undefined) {
            obj.minimumPayment = amount_1.Amount.toJSON(message.minimumPayment);
        }
        if (message.amountPaid !== undefined) {
            obj.amountPaid = amount_1.Amount.toJSON(message.amountPaid);
        }
        if (message.disputeAdjustment !== undefined) {
            obj.disputeAdjustment = amount_1.Amount.toJSON(message.disputeAdjustment);
        }
        if (message.status !== bill_status_1.BillStatus.INVALID_BILL_STATUS) {
            obj.status = (0, bill_status_1.billStatusToJSON)(message.status);
        }
        if (message.context !== undefined) {
            obj.context = statement_context_1.StatementContext.toJSON(message.context);
        }
        if (message.dueAtMs !== '0') {
            obj.dueAtMs = message.dueAtMs;
        }
        if (message.lastPaymentAtMs !== undefined && message.lastPaymentAtMs !== '0') {
            obj.lastPaymentAtMs = message.lastPaymentAtMs;
        }
        if (message.fullyPaidAtMs !== undefined && message.fullyPaidAtMs !== '0') {
            obj.fullyPaidAtMs = message.fullyPaidAtMs;
        }
        if (message.isCompleted !== false) {
            obj.isCompleted = message.isCompleted;
        }
        return obj;
    },
    create(base) {
        return exports.Bill.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBill();
        message.id = object.id ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.type = object.type ?? primary_account_type_1.PrimaryAccountType.INVALID_PRIMARY_ACCOUNT_TYPE;
        message.statementId = object.statementId ?? '';
        message.period = (object.period !== undefined && object.period !== null)
            ? statement_period_1.StatementPeriod.fromPartial(object.period)
            : statement_period_1.StatementPeriod.fromPartial({});
        message.amountDue = (object.amountDue !== undefined && object.amountDue !== null)
            ? amount_1.Amount.fromPartial(object.amountDue)
            : amount_1.Amount.fromPartial({});
        message.remainingAmountDue =
            (object.remainingAmountDue !== undefined && object.remainingAmountDue !== null)
                ? amount_1.Amount.fromPartial(object.remainingAmountDue)
                : amount_1.Amount.fromPartial({});
        message.minimumPayment = (object.minimumPayment !== undefined && object.minimumPayment !== null)
            ? amount_1.Amount.fromPartial(object.minimumPayment)
            : amount_1.Amount.fromPartial({});
        message.amountPaid = (object.amountPaid !== undefined && object.amountPaid !== null)
            ? amount_1.Amount.fromPartial(object.amountPaid)
            : amount_1.Amount.fromPartial({});
        message.disputeAdjustment =
            (object.disputeAdjustment !== undefined && object.disputeAdjustment !== null)
                ? amount_1.Amount.fromPartial(object.disputeAdjustment)
                : amount_1.Amount.fromPartial({});
        message.status = object.status ?? bill_status_1.BillStatus.INVALID_BILL_STATUS;
        message.context = (object.context !== undefined && object.context !== null)
            ? statement_context_1.StatementContext.fromPartial(object.context)
            : statement_context_1.StatementContext.fromPartial({});
        message.dueAtMs = object.dueAtMs ?? '0';
        message.lastPaymentAtMs = object.lastPaymentAtMs ?? '0';
        message.fullyPaidAtMs = object.fullyPaidAtMs ?? '0';
        message.isCompleted = object.isCompleted ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bill.js.map